import React from 'react';

import { envConfig } from 'config/env-config';
import { myPostBaseUrl } from 'config/track-config';
import { CustomerState } from 'models/Customer';
import { EnhancedWindow, HeaderConfig } from 'models/Window';
import { authService } from 'store/customer/utils/auth0.util';
import { useAppSelector } from 'store/store';
import { loginAndReturn } from 'utils/login.utils';

import { AP_HEADER_TEST_ID } from './Header.test-ids';

const updateHeader = (customer: CustomerState) => {
  const eWindow: EnhancedWindow = window;

  const headerConfig: HeaderConfig = {
    env: { envUrl: location.origin },
    appName: 'track',
    logout: {
      logoutType: 'OIDC',
      url: envConfig.url,
    },
    loginHandler: async function (): Promise<void> {
      await authService?.logout(myPostBaseUrl + '/track/', true);
      const redirectUrl = window.location.href;
      await loginAndReturn(redirectUrl);
    },
  };

  const isAuthed = customer.data?.isAuthenticated;

  const firstName = customer?.data?.info?.firstName;
  if (!isAuthed || !firstName) {
    // if not auth or no firstname, load anon header
    eWindow.__AUSPOST__?.header?.loadAuthenticationMode(false, headerConfig, authService);
  } else {
    // else set firstname and load auth header
    headerConfig.customer = { firstName };
    eWindow.__AUSPOST__?.header?.loadAuthenticationMode(true, headerConfig, authService);
  }
};

const Header: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({ ...props }) => {
  const customerState = useAppSelector((state) => state.customer);

  React.useEffect(() => {
    updateHeader(customerState);
  }, [customerState]);

  return <div id='auspost-header' data-testid={AP_HEADER_TEST_ID} {...props} onClick={toggleSidebarNav}></div>;
};

export default Header;

const toggleSidebarNav = () => {
  const branchBannerIframe = document.getElementById('branch-banner-iframe');
  const sidebarNavContainer = document.getElementById('sidebar-nav-container');
  if (!branchBannerIframe || !sidebarNavContainer) return;
  if (sidebarNavContainer.classList.contains('is-active')) {
    branchBannerIframe.style.position = 'fixed';
    branchBannerIframe.style.zIndex = '-1';
  } else {
    branchBannerIframe.style.zIndex = '99999';
  }
};
